/** Brief 12, `Mijozlar`, in Russian. */
export const ruB12Clients = {
  "clients.title": "Клиенты",
  "clients.scope.mine": "Мои клиенты",
  "clients.kpi.total": "Всего клиентов",
  "clients.kpi.totalHint": "В этом месяце +{count}",
  "clients.kpi.returning": "Возвращаются",
  "clients.kpi.returningHint": "2+ поездки",
  "clients.kpi.value": "Средняя ценность клиента",
  "clients.kpi.valueHint": "По всем поездкам",
  "clients.kpi.dormant": "Спящие клиенты",
  "clients.kpi.dormantHint": "Нет поездок 12 месяцев",
  "clients.today.returnedHint": "Спросите отзыв, предложите следующую поездку",
  "clients.today.birthdayHint": "На этой неделе · отправьте поздравление",
  "clients.today.passportHint": "В течение 6 месяцев · напомните обновить",
  "clients.today.yearAgoHint": "Предложение по тому же направлению",
  "clients.tab.all": "Все",
  "clients.tab.mine": "Мои клиенты",
  "clients.tab.regular": "Постоянные",
  "clients.tab.vip": "VIP",
  "clients.tab.dormant": "Спящие",
  "clients.tab.corporate": "Корпоративные",
  "clients.search": "Имя, телефон или паспорт",
  "clients.searchName": "Поиск по имени",
  "clients.filter.more": "Фильтр",
  "clients.filter.birthMonth": "Месяц рождения",
  "clients.filter.trips": "Поездок, не меньше",
  "clients.filter.total": "Общая сумма, от $",
  "clients.filter.apply": "Применить",
  "clients.filter.withoutOffer": "Предложение не отправлено",
  "clients.filter.empty": "Подходящих клиентов нет. Измените фильтр.",
  "clients.empty.title": "База клиентов пуста",
  "clients.empty.body": "Импортируйте клиентов из Excel или Google Sheets либо добавьте первого вручную.",
  "clients.empty.bodyAdd": "Добавьте первого клиента вручную.",
  "clients.empty.import": "Импортировать",
  "clients.empty.bodyRead": "Клиенты появятся здесь, когда агентство их добавит.",
  "clients.error.title": "Клиенты не загрузились",
  "clients.range": "{from}–{to} / {total}",
  "clients.prev": "Назад",
  "clients.next": "Вперёд",
  "clients.bulk.close": "Отменить",
  "clients.row.open": "Открыть карточку клиента",
  "clients.card.back": "Назад",
  "clients.card.owner": "Ответственный: {name}",
  "clients.card.thread": "Переписка",
  "clients.card.newDeal": "Создать сделку",
  "clients.card.notFound": "Клиент не найден или вам недоступен.",
  "clients.card.toList": "К списку клиентов",
  "clients.bron.title": "Брони",
  "clients.bron.section": "Раздел броней",
  "clients.bron.empty": "Броней пока нет",
  "clients.bron.search": "Искать тур",
  "clients.bron.travellers": "Туристов: {count}",
  "clients.bron.mismatch": "Имя отличается. В паспорте: {passport} · В брони: {booking}",
  "clients.bron.row.travellers": "Туристы",
  "clients.bron.row.passport": "Паспорт",
  "clients.bron.row.room": "Номер",
  "clients.bron.row.meal": "Питание",
  "clients.bron.row.insurance": "Страховка",
  "clients.bron.row.extras": "Дополнительно",
  "clients.bron.row.provider": "Поставщик",
  "clients.bron.row.note": "Заметка",
  "clients.bron.passportSoon": "{mask} · срок скоро истекает, {date}",
  "clients.bron.outbound": "Туда",
  "clients.bron.inbound": "Обратно",
  "clients.bron.page": "Страница брони",
  "clients.bron.deal": "Сделка №{number}",
  "clients.bron.nights": "Ночей: {count}",
  "clients.trips.title": "Прошлые поездки",
  "clients.trips.empty": "С нами ещё не путешествовал.",
  "clients.trips.line": "{date} · человек: {pax}",
  "clients.portrait.title": "портрет клиента",
  "clients.portrait.destination": "Направление",
  "clients.portrait.budget": "Бюджет",
  "clients.portrait.company": "С кем",
  "clients.portrait.month": "Месяц поездки",
  "clients.portrait.food": "Питание",
  "clients.portrait.unknown": "Недостаточно данных",
  "clients.portrait.needMore": "Для портрета нужно минимум 3 сообщения или 1 сделка",
  "clients.portrait.source": "Источник: {source} · с {year}",
  "clients.portrait.since": "Источник: с {year}",
  "clients.portrait.spouse": "С супругом(ой)",
  "clients.portrait.children": "Детей: {count} ({ages} лет)",
  "clients.portrait.perPerson": "на человека",
  "clients.portrait.perTrip": "на поездку",
  "clients.contact.title": "Контакты",
  "clients.contact.phone": "Телефон",
  "clients.contact.channel": "Канал",
  "clients.contact.owner": "Ответственный",
  "clients.contact.group": "Группа",
  "clients.contact.email": "Email",
  "clients.record.title": "Кратко",
  "clients.record.deals": "Сделки",
  "clients.record.sum": "Сумма",
  "clients.record.activity": "Последняя активность",
  "clients.record.discipline": "Дисциплина",
  "clients.count": "Клиентов: {count}",
  "clients.mobile.trips": "Поездок: {count}",
  "clients.error.bron": "Брони не загрузились",
  "clients.error.trips": "Поездки не загрузились",
  "clients.error.portrait": "Портрет не загрузился",
  "clients.table": "Список клиентов",
  "clients.new.mic": "Голосовой ввод",
  "clients.new.micFailed": "Не удалось распознать голос",
  "clients.new.firstName": "Имя",
  "clients.new.lastName": "Фамилия",
  "clients.new": "Новый клиент",
} as const;
